const RecordIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      fontSize="inherit"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_617_4107)">
        <circle cx="10" cy="10" r="10" fill="white" />
        <circle cx="10" cy="10" r="6" fill="#EC4F3C" />
      </g>
      <defs>
        <clipPath id="clip0_617_4107">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RecordIcon;
